export enum FeatureFlagEnum {
  BRAND_CURRENCY_LOCALE = 'BRAND_CURRENCY_LOCALE',
  CURRENCY_TYPE = 'CURRENCY_TYPE',
  ENABLE_ADMIN_CHANGE_SPLIT_SETTINGS = 'ENABLE_ADMIN_CHANGE_SPLIT_SETTINGS',
  ENABLE_BUSINESS_POLICIES = 'ENABLE_BUSINESS_POLICIES',
  ENABLE_CASES = 'ENABLE_CASES',
  ENABLE_CHAT = 'ENABLE_CHAT',
  ENABLE_CHAT_IN_CASES = 'ENABLE_CHAT_IN_CASES',
  ENABLE_CHAT_VIDEO_CALL = 'ENABLE_CHAT_VIDEO_CALL',
  ENABLE_DYNAMIC_CATALOG = 'ENABLE_DYNAMIC_CATALOG',
  ENABLE_RACHEL_CHAT = 'ENABLE_RACHEL_CHAT',
  ENABLE_FORCE_CUSTOMER_FILE_IMPORT = 'ENABLE_FORCE_CUSTOMER_FILE_IMPORT',
  ENABLE_FORCE_UPDATE_ORDER_CONDITIONS = 'ENABLE_FORCE_UPDATE_ORDER_CONDITIONS',
  ENABLE_FORCE_PRODUCT_FILE_IMPORT = 'ENABLE_FORCE_PRODUCT_FILE_IMPORT',
  ENABLE_NPS = 'ENABLE_NPS',
  ENABLE_ORDER_BOOK_SALES_OPPORTUNITY = 'ENABLE_ORDER_BOOK_SALES_OPPORTUNITY',
  ENABLE_ORDER_BOOK_SALES_OPPORTUNITY_CONVERSIONS = 'ENABLE_ORDER_BOOK_SALES_OPPORTUNITY_CONVERSIONS',
  ENABLE_ORDER_MARKUP = 'ENABLE_ORDER_MARKUP',
  ENABLE_REPORT_ORDER_INCOME = 'ENABLE_REPORT_ORDER_INCOME',
  ENABLE_REPORT_ORDER_INCOME_BY_CUSTOMER_BY_ORDER = 'ENABLE_REPORT_ORDER_INCOME_BY_CUSTOMER_BY_ORDER',
  ENABLE_REPORT_SALES_BY_CATEGORY = 'ENABLE_REPORT_SALES_BY_CATEGORY',
  ENABLE_REPORT_SALES_BY_COLLECTION = 'ENABLE_REPORT_SALES_BY_COLLECTION',
  ENABLE_REPORT_SALES_BY_CUSTOMER = 'ENABLE_REPORT_SALES_BY_CUSTOMER',
  ENABLE_REPORT_SALES_BY_ORDER = 'ENABLE_REPORT_SALES_BY_ORDER',
  ENABLE_REPORT_SALES_BY_PERIOD = 'ENABLE_REPORT_SALES_BY_PERIOD',
  ENABLE_REPORT_SALES_BY_PRODUCT = 'ENABLE_REPORT_SALES_BY_PRODUCT',
  ENABLE_REPORT_SALES_BY_SALES_REPRESENTATIVE = 'ENABLE_REPORT_SALES_BY_SALES_REPRESENTATIVE',
  ENABLE_REPORT_SALES_TARGET_BY_SALES_REP = 'ENABLE_REPORT_SALES_TARGET_BY_SALES_REP',
  ENABLE_SATISFACTION_SURVEY = 'ENABLE_SATISFACTION_SURVEY',
  ENABLE_SALES_TARGET = 'ENABLE_SALES_TARGET',
  ENABLE_SALES_REPORT_BY_PRODUCT_CLASSIFICATION = 'ENABLE_SALES_REPORT_BY_PRODUCT_CLASSIFICATION',
  ENABLE_REPORT_SSE_DOWNLOAD = 'ENABLE_REPORT_SSE_DOWNLOAD',
  ENABLE_SALES_OPPORTUNITY = 'ENABLE_SALES_OPPORTUNITY',
  ENABLE_SEARCH_BRANDS = 'ENABLE_SEARCH_BRANDS',
  ENABLE_SELLER_TO_CREATE_OR_CHANGE_SUGGESTED_ORDER = 'ENABLE_SELLER_TO_CREATE_OR_CHANGE_SUGGESTED_ORDER',
  ENABLE_SHARE_SUGGESTED_ORDER = 'ENABLE_SHARE_SUGGESTED_ORDER',
  ENABLE_STORE_POINT_OF_SALE_MODAL = 'ENABLE_STORE_POINT_OF_SALE_MODAL',
  ENABLE_SUGGESTED_ORDER_V2 = 'ENABLE_SUGGESTED_ORDER_V2',
  ENABLE_SELLOUT_IN_COMMERCE = 'ENABLE_SELLOUT_IN_COMMERCE',
  COMMERCE_MIN_VALUE_TO_SHOW_SELLOUT_TAG = 'COMMERCE_MIN_VALUE_TO_SHOW_SELLOUT_TAG',
  ENABLE_UPDATE_PRICES = 'ENABLE_UPDATE_PRICES',
  RESET_INTEGRATION = 'RESET_INTEGRATION',
  ENABLE_REPORTS_PERIOD_FILTER = 'ENABLE_REPORTS_PERIOD_FILTER',
  ENABLE_MASS_OPPORTUNITY_CHANGE_PHASE = 'ENABLE_MASS_OPPORTUNITY_CHANGE_PHASE',
  ENABLE_LIMIT_STOCK_FIELD = 'ENABLE_LIMIT_STOCK_FIELD',
  ENABLE_LOCALS = 'ENABLE_LOCALS',
  ENABLE_SKU_WEIGHT_AND_DIMENSIONS = 'ENABLE_SKU_WEIGHT_AND_DIMENSIONS',
  ORDERS_TOTAL = 'ORDERS_TOTAL',
  ENABLE_BUSINESS_POLICY_VOUCHER = 'ENABLE_BUSINESS_POLICY_VOUCHER',
  VALIDATE_CLASSIFICATION_AND_CONTACT_ON_UPDATE_USER = 'VALIDATE_CLASSIFICATION_AND_CONTACT_ON_UPDATE_USER',
  REPORT_DATABASE_MAPPER = 'REPORT_DATABASE_MAPPER',
  ENABLE_INVOICES = 'ENABLE_INVOICES',
  ENABLE_TECEO_OFFLINE = 'ENABLE_TECEO_OFFLINE',
  ACCEPT_SUGGESTED_ORDER = 'ACCEPT_SUGGESTED_ORDER',
  ENABLE_REPORT_SELLOUT_SALES_BY_PRODUCT = 'ENABLE_REPORT_SELLOUT_SALES_BY_PRODUCT',
  ENABLE_REPORT_SELLOUT_SALES_BY_PRODUCT_COLOR = 'ENABLE_REPORT_SELLOUT_SALES_BY_PRODUCT_COLOR',
  ENABLE_SELLOUT_REPORTS = 'ENABLE_SELLOUT_REPORTS',
  ENABLE_REPORT_SALES_BY_ORDER_BY_SUPPLIER = 'ENABLE_REPORT_SALES_BY_ORDER_BY_SUPPLIER',
  ENABLE_REPORT_SALES_BY_ORDER_ITEM_BY_SUPPLIER = 'ENABLE_REPORT_SALES_BY_ORDER_ITEM_BY_SUPPLIER',
  ENABLE_UPDATE_ORDER_ON_APPROVE_ORDER_MASS_ACTION = 'ENABLE_UPDATE_ORDER_ON_APPROVE_ORDER_MASS_ACTION',
  MAX_ITEMS_TO_PASTE_IN_PRODUCT_DETAILS = 'MAX_ITEMS_TO_PASTE_IN_PRODUCT_DETAILS',
  ENABLE_ACCOUNTS_RECEIVABLE = 'ENABLE_ACCOUNTS_RECEIVABLE',
  ENABLE_HIDE_WHOLESALE_RETAIL_PRODUCTS_SETTINGS = 'ENABLE_HIDE_WHOLESALE_RETAIL_PRODUCTS_SETTINGS',
  PDF_ORDER_V2_MAX_ORDERS_LIMIT = 'PDF_ORDER_V2_MAX_ORDERS_LIMIT',
  ENABLE_PRODUCT_MATCH = 'ENABLE_PRODUCT_MATCH',
  ENABLE_LIGHTDASH_REPORTS = 'ENABLE_LIGHTDASH_REPORTS',
  ENABLE_SUPPLIER_ROLE_REPORTS_RESTRICTION = 'ENABLE_SUPPLIER_ROLE_REPORTS_RESTRICTION',
  ALLOW_EDIT_SYNCHRONIZED_CUSTOMER = 'ALLOW_EDIT_SYNCHRONIZED_CUSTOMER',
}
